module.exports = __webpack_public_path__ + "media/St 4-phone-tablet-correct.3ca202b0.wav";